import {apiConfig} from "../apiConfig"
import useFetchClient from "./useFetchClient"
import {CreateOrUpdateCustomerPortalRoleModel, CustomerPortalRoleModel} from "../redux/types";
import {useAppDispatch} from "../redux/hooks";
import {
  loading,
  portalRoleCreated,
  portalRoleCreateFailure,
  portalRoleDeleted,
  portalRoleDeleteFailure,
  portalRolesFetched,
  portalRolesFetchFailure,
  portalRoleUpdated,
  portalRoleUpdateFailure
} from "../redux/slices/customerPortalRolesSlice";

const useCustomerPortalRolesActions = () => {
  const fetchClient = useFetchClient()
  const dispatch = useAppDispatch()

  const getRoles = () => {
    dispatch(loading())

    return fetchClient.get(apiConfig.routes.customerRoles)
      .then(response => {
        dispatch(portalRolesFetched(response.data as CustomerPortalRoleModel[]))
      })
      .catch(error => {
        console.log('getRoles error:', error)
        dispatch(portalRolesFetchFailure(error))
      })
  }

  const createRole = (role: CreateOrUpdateCustomerPortalRoleModel) => {
    dispatch(loading())

    return fetchClient.post(apiConfig.routes.customerRoles, role)
      .then(response => {
        dispatch(portalRoleCreated(response.data as CustomerPortalRoleModel))
      })
      .catch(error => {
        console.log('createRole error:', error)
        dispatch(portalRoleCreateFailure(error))
      })
  }

  const updateRole = (roleId: string, role: CreateOrUpdateCustomerPortalRoleModel) => {
    dispatch(loading())
    const url = `${apiConfig.routes.customerRoles}${roleId}`

    return fetchClient.post(url, role)
      .then(response => {
        dispatch(portalRoleUpdated(response.data as CustomerPortalRoleModel))
      })
      .catch(error => {
        console.log('updateRole error:', error)
        dispatch(portalRoleUpdateFailure(error))
      })
  }

  const deleteRole = (roleId: string) => {
    dispatch(loading())
    const url = `${apiConfig.routes.customerRoles}${roleId}`

    return fetchClient.delete(url)
      .then(() => {
        dispatch(portalRoleDeleted(roleId))
      })
      .catch(error => {
        console.log('deleteRole error:', error)
        dispatch(portalRoleDeleteFailure(error))
      })
  }

  return {
    getRoles,
    createRole,
    updateRole,
    deleteRole
  }
}

export default useCustomerPortalRolesActions
